import { render, staticRenderFns } from "./ProjectEpicsRadioList.vue?vue&type=template&id=3f84b41c&scoped=true"
import script from "./ProjectEpicsRadioList.vue?vue&type=script&lang=js"
export * from "./ProjectEpicsRadioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84b41c",
  null
  
)

export default component.exports